import React, {useState, useEffect} from 'react';
import { gql } from 'apollo-boost';
import { useMutation } from '@apollo/react-hooks';

import VerifyOtp from './VerifyOtp';

/** @import {VerifyOtpOnSuccess} from './VerifyOtpTypes' */

const SEND_OTP = gql`
  mutation SendLoggedInOtp($request : SendOtpRequestType!){
    sendLoggedInOtp(request:$request) {
      success
      verificationToken
    }
  }  
`;

const SmsOtp = (/** @type { { mobileNumber: string; analyticsRegion: string; analyticsAction: string; onSuccess: VerifyOtpOnSuccess; } } */ props) => {
  const [verificationToken, setVerificationToken] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [send] = useMutation(SEND_OTP);

  const sendOtp = async () => {
    setOtpSent(true);

    const otpResult = await send({
      variables: {
        request: {}
      }
    });

    setVerificationToken(otpResult.data.sendLoggedInOtp.verificationToken);
  }

  useEffect(() => {
    if (otpSent)
      return;
    
    sendOtp();
  }, [otpSent]);

  return <VerifyOtp 
    mobileNumber={props.mobileNumber} 
    verificationToken={verificationToken} 
    onSuccess={props.onSuccess}
    analyticsRegion={props.analyticsRegion || 'unknown'}
    analyticsAction={props.analyticsAction || 'unknown'}/>
};

export default SmsOtp;